import { render } from "./LazyImage.vue?vue&type=template&id=b98556e6"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__